import { render } from "./ReportsSettings.vue?vue&type=template&id=2c766c96&scoped=true"
import script from "./ReportsSettings.vue?vue&type=script&lang=js"
export * from "./ReportsSettings.vue?vue&type=script&lang=js"

import "./ReportsSettings.vue?vue&type=style&index=0&id=2c766c96&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c766c96"]])

export default __exports__